export class HouseInfo {
    id: number;
    address: string;
    frame: number;

    constructor(id: number, address: string, frame: number) {
        this.id = id;
        this.address = address;
        this.frame = frame;
    }
}

export class House extends Phaser.GameObjects.Zone {
    id: number;
    address: string;
    frame: number;

    constructor(scene: Phaser.Scene, x: number, y: number, width: number, height: number, info: HouseInfo) {
        super(scene, x, y, width, height);
        this.id = info.id;
        this.address = info.address;
        this.frame = info.frame;

        this.setOrigin(0);
        this.setDepth(5);

        scene.add.existing(this);
    }

    public static Houses: HouseInfo[] = [
        new HouseInfo(1, "101 Lightyear Lane.", 0),
        new HouseInfo(2, "102 Lightyear Lane.", 1),
        new HouseInfo(3, "103 Lightyear Lane.", 2),
        new HouseInfo(4, "600 Big Bang Blvd.", 6),
        new HouseInfo(5, "101 Asteroid Alley", 3),
        new HouseInfo(6, "201 Asteroid Alley", 4),
        new HouseInfo(7, "308 Asteroid Alley", 5),
    ];
}




// WEBPACK FOOTER //
// ./src/games/MailDeliveryGame/objects/House.ts